<template>
    <v-container>
        <v-overlay :value="isLoading" absolute>
            <v-progress-circular :size="70" :width="7" indeterminate></v-progress-circular>
        </v-overlay>
        <!-- ============================================================================================================================ -->
        <v-card elevation="24" class="mb-3">
            <v-toolbar color="indigo" dark>
                <v-toolbar-title class="font-weight-bold">{{ dbDevice.name }}</v-toolbar-title>
            </v-toolbar>
            <v-card-text class="pa-0">
                <v-responsive :aspect-ratio="16 / 9">
                    <!--
                    <img :src="jpgImg" width="100%" />
                    -->
                    <v-img fluid :src="jpgImg">
                        <h4 class="white--text">{{ dbCamera.name }}</h4>
                    </v-img>
                </v-responsive>
                <v-sheet class="ma-2">
                    <v-progress-linear color="light-blue" height="30" :value="Math.floor((mjpgCountDown / mjpgSetCountDown) * 100)" striped></v-progress-linear>
                    <v-btn block color="warning" @click="mqttMjpg()">
                        <h3>
                            ライブ映像<small>({{ mjpgSetCountDown }}秒)</small>
                        </h3>
                    </v-btn>
                </v-sheet>
                <v-card class="mt-5 pa-3">
                    <v-card-text>
                        <h3>【給餌速度】</h3>
                        <v-slider v-model="oneShot.feed_motor" min="1" max="9">
                            <template v-slot:append>
                                <v-text-field readonly v-model="oneShot.feed_motor" class="ma-0 pa-0" hide-details single-line type="number" style="width: 60px"></v-text-field>
                            </template>
                        </v-slider>

                        <h3>【飛散レベル】</h3>
                        <v-slider v-model="oneShot.sprinkle_motor" min="1" max="9">
                            <template v-slot:append>
                                <v-text-field readonly v-model="oneShot.sprinkle_motor" class="ma-0 pa-0" hide-details single-line type="number" style="width: 60px"></v-text-field>
                            </template>
                        </v-slider>

                        <h3>【動作秒数】(1〜990 秒で設定可能)</h3>
                        <!--
                        <v-slider v-model="oneShot.feed_sec" min="5" max="990" step="1">
                            <template v-slot:append>
                                <v-text-field v-model="oneShot.feed_sec" class="ma-0 pa-0" hide-details single-line type="number" step="1" style="width: 60px"></v-text-field>
                            </template>
                        </v-slider>
                        -->
                        <v-text-field v-model="oneShot.feed_sec" class="ma-0 pa-0" hide-details single-line type="number" step="1" inputmode="numeric" outlined dense></v-text-field>

                        <v-card class="pa-3 mt-5">
                            <h3>【今回の給餌量】{{ feedOutWeight(oneShot.feed_motor, oneShot.feed_sec) }}</h3>
                            <div class="ma-8"></div>
                            <v-row>
                                <v-col>
                                    <v-btn block color="success" @click="mqttOneShotStart()" :disabled="Number(oneShot.feed_sec) <= 0 || Number(oneShot.feed_sec) > 990"><h3>開始!</h3></v-btn>
                                </v-col>
                                <v-col>
                                    <v-btn block color="error" @click="mqttOneShotStop()"><h3>停止!</h3></v-btn>
                                </v-col>
                            </v-row>
                        </v-card>
                        <div class="mb-5"></div>
                    </v-card-text>
                </v-card>
            </v-card-text>
        </v-card>
        <!-- ============================================================================================================================ -->
    </v-container>
</template>

<script>
import Config from "@/config.json";
import mqtt from "mqtt";
export default {
    name: "LiveCam",
    components: {},
    data() {
        return {
            jwt: "",
            myInfo: [],
            dbSite: { id: 0, name: "" },
            device_id: 0,
            feeder_id: 0,
            camera_id: 0,
            dbDevice: [],
            dbFeeder: [],
            dbCamera: [],
            noImage: require("@/assets/no-image.jpg"),
            jpgImg: "",
            mjpgCountDown: 0,
            mjpgSetCountDown: 180,
            //-----------------------------
            mqttHost: Config.mqttHost,
            mqttID: Config.mqttID,
            mqttPW: Config.mqttPW,
            mqttTopicPub: Config.mqttTopicPub,
            mqttTopicSub: Config.mqttTopicSub,
            mqttClient: { connected: false },
            //-----------------------------
            oneShot: {
                feed_motor: 2,
                sprinkle_motor: 3,
                feed_sec: 30,
            },
            optMotor: [
                { text: "1", value: "1" },
                { text: "2", value: "2" },
                { text: "3", value: "3" },
                { text: "4", value: "4" },
                { text: "5", value: "5" },
                { text: "6", value: "6" },
                { text: "7", value: "7" },
                { text: "8", value: "8" },
                { text: "9", value: "9" },
            ],
            optTime: [
                { text: "1", value: "1" },
                { text: "2", value: "2" },
                { text: "3", value: "3" },
                { text: "4", value: "4" },
                { text: "5", value: "5" },
                { text: "10", value: "10" },
                { text: "15", value: "15" },
                { text: "30", value: "30" },
                { text: "60", value: "60" },
                { text: "90", value: "90" },
                { text: "120", value: "120" },
                { text: "180", value: "180" },
                { text: "240", value: "240" },
            ],
            isLoading: false,
        };
    },
    //===========================================================================
    created: async function () {
        this.jwt = this.$localStorage.get("jwt");
        if (!this.jwt) {
            this.$router.push({ name: "Login" });
            return;
        }
        this.myInfo = this.$jwt.decode(this.jwt);
        if (this.myInfo && this.myInfo.exp < this.$moment().unix()) {
            this.$router.push({ name: "Login" });
            return;
        }
        //-----------------------
        if (this.$localStorage.get("oneshot")) {
            this.oneShot = JSON.parse(this.$localStorage.get("oneshot"));
        }
        //-----------------------
        this.isLoading = true;
        //-----------------------
        this.device_id = this.$route.params.device_id;
        this.feeder_id = this.$route.params.feeder_id;
        this.camera_id = this.$route.params.camera_id;
        this.jpgImg = this.noImage + "?rnd=" + this.$moment().unix();
        // this.jpgImg = "http://root:987654321a@114.157.132.176:33001/video1s1.mjpg";
        //-----------------------
        //非同期でAxiosGet
        const promiseDevice = this.axiosGetDevices();
        const promiseFeeder = this.axiosGetFeeders();
        const promiseCamera = this.axiosGetCameras();
        //-----------------------
        //上記の終了を待つ
        await promiseDevice;
        await promiseFeeder;
        await promiseCamera;
        //-----------------------
        await new Promise((r) => setTimeout(r, 500));
        this.isLoading = false;
        //-----------------------
        this.connectMqtt();
        //-----------------------
        window.scrollTo(0, 0);
        this.putUserOperated();
    },
    //========================================================
    mounted() {},
    //========================================================
    beforeDestroy: async function () {
        this.disconnectMqtt();
        this.jpgImg = this.noImage + "?rnd=" + this.$moment().unix();
    },
    //========================================================
    methods: {
        //===================================================
        async axiosGetDevices() {
            await this.axios({
                method: "GET",
                url: "/web/api/devices",
                params: { id: this.device_id },
                headers: { Authorization: "Bearer " + this.jwt },
                timeout: 30000,
            }).then((response) => {
                this.dbDevice = response.data.json[0];
            });
        },
        //===================================================
        async axiosGetFeeders() {
            await this.axios({
                method: "GET",
                url: "/web/api/feeders",
                params: { id: this.feeder_id },
                headers: { Authorization: "Bearer " + this.jwt },
                timeout: 30000,
            }).then((response) => {
                this.dbFeeder = response.data.json[0];
            });
        },
        //====================================================
        async axiosGetCameras() {
            await this.axios({
                method: "GET",
                url: "/web/api/cameras",
                params: { id: this.camera_id },
                headers: { Authorization: "Bearer " + this.jwt },
                timeout: 30000,
            }).then(async (response) => {
                this.dbCamera = response.data.json[0];
            });
        },
        //====================================================
        async connectMqtt() {
            //-----------------
            if (this.mqttClient.connected) return true;
            //-----------------
            const gThis = this;
            //-----------------
            this.mqttClient = mqtt.connect(
                this.mqttHost
                //{ username: this.mqttID, password: this.mqttPW }
            );
            //-----------------
            this.mqttClient.on("connect", function () {
                self.console.log("MQTT Connected !!");
            });
            //-----------------
            this.mqttClient.on("message", function (topic, message) {
                let subMsg = message.toString();
                let obj = JSON.parse(subMsg);
                if (obj.camera_id && obj.camera_id == gThis.dbCamera["id"]) {
                    if (obj.countDown) gThis.mjpgCountDown = obj.countDown - 1;
                }
            });
            //-----------------
            const mac = this.dbDevice["mac"];
            this.mqttClient.subscribe(this.mqttTopicSub + "/" + mac);
        },
        //====================================================
        disconnectMqtt() {
            if (!this.mqttClient.connected) return true;
            this.mqttClient.end();
        },
        //====================================================
        publishMessage(mac, key, val) {
            const topic = this.mqttTopicPub + "/" + mac;
            const pubMessage = { type: "order", key: key, val: val, mac: mac };
            if (this.mqttClient.connected) {
                this.mqttClient.publish(topic, JSON.stringify(pubMessage));
            }
            this.putUserOperated();
        },
        //====================================================
        mqttOneShotStart() {
            const mac = this.dbDevice["mac"];
            const key = "oneshot";
            const val = JSON.stringify({
                mode: "start",
                feed_motor: this.oneShot.feed_motor,
                sprinkle_motor: this.oneShot.sprinkle_motor,
                feed_sec: this.oneShot.feed_sec,
                camera_id: this.camera_id,
            });
            this.publishMessage(mac, key, val);
            this.$localStorage.set("oneshot", JSON.stringify(this.oneShot));
        },
        //====================================================
        mqttOneShotStop() {
            const mac = this.dbDevice["mac"];
            const key = "oneshot";
            const val = JSON.stringify({
                mode: "stop",
                feed_motor: this.oneShot.feed_motor,
                sprinkle_motor: this.oneShot.sprinkle_motor,
                feed_sec: this.oneShot.feed_sec,
            });
            this.publishMessage(mac, key, val);
            this.$localStorage.set("oneshot", JSON.stringify(this.oneShot));
        },
        //====================================================
        async mqttMjpg() {
            //------------------------------
            const mac = this.dbDevice["mac"];
            const key = "mjpg";
            const val = JSON.stringify({
                camera_id: this.dbCamera["id"],
                camera_ip: this.dbCamera["local_ip"],
                camera_port: this.dbCamera["local_port"],
                countDown: this.mjpgSetCountDown,
            });
            this.publishMessage(mac, key, val);
            //------------------------------
            this.isLoading = true;
            if (this.mjpgCountDown < 5) {
                await new Promise((r) => setTimeout(r, 1000 * 5));
            }
            //------------------------------
            // let mjpgUrl = "https://";
            // if (this.dbCamera["loginid"] && this.dbCamera["loginpw"]) {
            //     mjpgUrl += this.dbCamera["loginid"] + ":" + this.dbCamera["loginpw"] + "@";
            // }
            // mjpgUrl += "v4feed.fec-labo.com";
            // mjpgUrl = "/" + this.dbCamera["id"] + this.dbCamera["mjpg_path"];
            // mjpgUrl += "?rnd=" + this.$moment().unix();
            // this.jpgImg = mjpgUrl;
            // this.jpgImg = "http://root:987654321a@v4feed.fec-labo.com/8001/video1s1.mjpg";
            //------------------------------
            let mjpgUrl = "https://v4feed.fec-labo.com";
            mjpgUrl += "/mjpeg/" + this.dbCamera["id"];
            mjpgUrl += "?rnd=" + this.$moment().unix();
            this.jpgImg = mjpgUrl;
            //------------------------------
            this.isLoading = false;
        },
        //====================================================
        feedOutWeight(feed_motor, feed_sec) {
            let gpm = 0; // 1分間の吐出量 (gram par minutes)
            let ret = "---";
            if (isNaN(feed_motor)) return ret;
            if (isNaN(feed_sec)) return ret;
            if (!feed_motor) return ret;
            if (!feed_sec) return ret;

            if (feed_motor == 1) gpm = this.dbFeeder["output1"];
            if (feed_motor == 2) gpm = this.dbFeeder["output2"];
            if (feed_motor == 3) gpm = this.dbFeeder["output3"];
            if (feed_motor == 4) gpm = this.dbFeeder["output4"];
            if (feed_motor == 5) gpm = this.dbFeeder["output5"];
            if (feed_motor == 6) gpm = this.dbFeeder["output6"];
            if (feed_motor == 7) gpm = this.dbFeeder["output7"];
            if (feed_motor == 8) gpm = this.dbFeeder["output8"];
            if (feed_motor == 9) gpm = this.dbFeeder["output9"];
            ret = (gpm / 60) * feed_sec;
            ret = ret / 1000;
            ret = ret.toFixed(3);
            ret = String(ret) + "kg";
            return ret;
        },
        //====================================================
        putUserOperated() {
            this.axios({
                method: "PUT",
                url: "/web/api/user_operated",
                headers: { Authorization: "Bearer " + this.jwt },
                timeout: 30000,
            });
        },
        //====================================================
    },
};
</script>
